import { render, staticRenderFns } from "./wallerrecord.vue?vue&type=template&id=1492d2d0&scoped=true"
import script from "./wallerrecord.vue?vue&type=script&lang=js"
export * from "./wallerrecord.vue?vue&type=script&lang=js"
import style0 from "./wallerrecord.vue?vue&type=style&index=0&id=1492d2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492d2d0",
  null
  
)

export default component.exports